import React from 'react';
import BaseButton from './baseButton';
import { filterProps } from './handle';
import { NOT_SUPPORT_PROPS } from './constant';
export function Button(props) {
    // 这里剔除style属性，不允许外部自定义按钮属性
    const buttonProps = filterProps(props, NOT_SUPPORT_PROPS);
    return <BaseButton {...buttonProps}/>;
}
